var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4442 90L3.49999 89.9999H0L0 81.48L3.49824 78.0017L3.49824 11.9984L3.49691e-06 8.52012L3.49691e-06 0.000137329H3.49824V7.62939e-06L90 0.000144958V83.4286L83.4442 90Z",
    fill: "#82FFA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36.3077L40.7876 58L28 44.9231L32.2124 40.6154L40.7876 49.3846L57.7876 32L62 36.3077Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectSuccess);
export default __webpack_public_path__ + "static/media/rect-success.c5d91a7c2069b7e0731c47879630c341.svg";
export { ForwardRef as ReactComponent };